import React from 'react';
import classNames from 'classnames';
import CollapsingList from './collapsing_list';
import { SelectFacetOption } from './select_facet_option';
import { FilterProps, filterID, WidgetType } from './search_filters';
import { RCToggledContent } from '@reverbdotcom/cadence/components';

const COLLAPSE_THRESHOLD = 7;


export default function SelectFacet({
  filter,
  pageSection,
  trackingQuery,
  collapsible = false,
  defaultOpen = false,
}: FilterProps) {
  const labelId = `${pageSection}--${filterID(filter)}-lbl`;

  const heading = (
    <legend
      id={labelId}
      className={!collapsible ? 'facet__heading' : ''}
    >
      {filter.name}
    </legend>
  );

  const filterOptions = (
    <CollapsingList
      countThreshold={filter.aggregationName === 'TRAITS' ? 3 : COLLAPSE_THRESHOLD}
    >
      {filter.options.map((option) => (
        <SelectFacetOption
          key={option.name}
          option={option}
          checkbox={filter.widgetType === WidgetType.CHECKBOX}
          trackingQuery={trackingQuery}
        />
      ))}
    </CollapsingList>
  );

  const classes = classNames('facet', { 'facet--collapsible': collapsible });

  if (collapsible) {
    const anySelected = filter.options.some(opt => (opt.selected && !opt.all));

    return (
      <fieldset className={classes}>
        <RCToggledContent
          id={labelId}
          heading={heading}
          defaultOpen={defaultOpen || anySelected}
        >
          {filterOptions}
        </RCToggledContent>
      </fieldset>
    );
  }

  return (
    <fieldset
      className={classes}
    >
      {heading}
      {filterOptions}
    </fieldset>
  );
}
